import { twMerge } from "tailwind-merge";

import customMixIcon from "@assets/custom-mix.svg";
import { ExploreBudgetsTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import { MMMTab } from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";

import { BUDGET_MIX_WIDTH_WITH_CHART } from "../budget-mix-chart/constants";

export const CreateYourOwnMixCard = ({
  openAddSpendDataModal,
}: {
  openAddSpendDataModal: () => void;
}) => {
  const trackMMMEvent = useTrackMMMEvent(MMMTab.EXPLORE_BUDGETS);

  return (
    <div
      className={twMerge(
        "card border border-v2-secondary hover:border-cosmic",
        "bg-v2-primary rounded-xl flex justify-center items-center cursor-pointer",
        "bg-v2-secondary border-none h-full",
      )}
      onClick={() => {
        trackMMMEvent({
          component: ExploreBudgetsTrackedComponent.CUSTOM_MIX_BUDGET_MIX_CARD,
          action: "onClick",
          actionInfo: "Goto create custom mix tab",
        });
        openAddSpendDataModal();
      }}
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='%237081FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
        width: `${BUDGET_MIX_WIDTH_WITH_CHART}px`,
      }}
    >
      <div className="flex flex-col items-center justify-center h-full">
        <img
          src={customMixIcon}
          alt="Custom mix"
          className="h-[7rem]"
          style={{
            height: "2rem",
            width: "auto",
          }}
        />
        <div className=" font-bold text-center px-6 hover:text-cosmic+2">
          <div className=" text-v2-primary text-xl">
            Create your own budget mix
          </div>
          <div className=" text-v2-primary text-md font-normal">
            & See what MMM+ predicts
          </div>
        </div>
      </div>
    </div>
  );
};
